<template>
  <span class="app-arrow" :class="setDirection"></span>
</template>

<script>
export default {
  name: 'AppArrow',

  props: {
    direction: {
      type: String,
      default: 'up',
    },
  },
  computed: {
    setDirection() {
      return `--arrow-${this.direction}`
    },
  },
}
</script>

<style scoped>
.app-arrow {
  position: absolute;
  pointer-events: none;
  border-width: 1px;
  border-style: solid;
  border-right-color: var(--c-secondary-400);
  border-bottom-color: var(--c-secondary-400);
  border-image: initial;
  clip-path: polygon(100% 100%, 0px 100%, 100% 0px);
  border-top-left-radius: 100%;
  width: 15px;
  height: 15px;
  background-color: inherit;
  transform: rotate(45deg);
  border-top-color: transparent !important;
  border-left-color: transparent !important;
}

.--arrow-up {
  top: -7px;
  left: calc(50% - 10px);
  transform: rotate(225deg);
}

.--arrow-down {
  bottom: -7px;
  left: calc(50% - 10px);
}

.--arrow-right {
  right: -7px;
  top: calc(50% - 10px);
  transform: rotate(-45deg);
}

.--arrow-left {
  left: -7px;
  top: calc(50% - 10px);
  transform: rotate(135deg);
}

/* .--arrow-up {
  top: -8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid var(--c-primary-400);
}

.--arrow-down {
  bottom: -8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid var(--c-primary-400);
}

.--arrow-right {
  top: 0;
  bottom: 0;
  right: -8px;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid var(--c-primary-400);
}

.--arrow-left {
  top: 0;
  bottom: 0;
  left: -8px;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid var(--c-primary-400);
} */
</style>
